module.exports = __webpack_public_path__ + "assets/img/loox.f46936ff.png";